export const HAS_ENTRY_DATA_CLASSIFICATION = [
  "C000",
  "C005",
  "C006",
  "C021",
  "C013",
  "C016",
  "C001",
  "C101",
];
